import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectShouldDisplayHomeBanner } from '../../store/ui/ui.selectors'
import { TAG_PUBLISHER } from '../analytics/analytics.tagids.constants'
import { PUB_TAG } from '../analytics/PublisherTagsService'
import useConfigureAndSendTag from '../analytics/useConfigureAndSendTag'
import { withOnlyGE } from '../Device'
import cross from '../genericComponents/assets/cross.svg'
import { withFrenchSite } from '../i18n/i18nSite'
import SVGIcon from '../svg/SVGIcon'
import s from './BlueAdBanner.less'

import { hideUiHomeBanner } from '../../store/ui/uiSlice'
import { useAbTestVariant } from '../abtest/useAbTest'
const bannerIconSize = 38

const BlueAdBanner = () => {
  const dispatch = useDispatch()

  const ABTEST_ID = 'bluebanner'
  const abTest = useAbTestVariant(ABTEST_ID)
  const showBanner = useSelector(selectShouldDisplayHomeBanner)
  const [shouldDisplayBanner, setShouldDisplayBanner] = useState(showBanner)
  const configureAndSendTag = useConfigureAndSendTag()

  useEffect(() => {
    if (shouldDisplayBanner)
      configureAndSendTag({
        type: TAG_PUBLISHER,
        tagInfo: { tag: PUB_TAG.PUB_BANNIERE_EDITO_PUB },
        isImpression: true
      })
  }, [])

  if (!abTest) return <></>

  const bannerTitle = abTest.data?.title
  const bannerDescription = abTest.data?.description
  const bannerUrl = abTest.data?.url
  const bannerImage = abTest.data?.image

  const onClickBanner = source => {
    if (source === 'close') {
      setShouldDisplayBanner(false)
      dispatch(hideUiHomeBanner())
    }
  }

  if (!shouldDisplayBanner) return <></>

  return (
    <div className={s.bannerContainer}>
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a
        className={s.bannerAnchor}
        href={bannerUrl}
        target="_blank"
        rel="nofollow noopener"
        onClick={() => {
          onClickBanner('access')
          configureAndSendTag({
            type: TAG_PUBLISHER,
            tagInfo: { tag: PUB_TAG.PUB_BANNIERE_EDITO_PUB }
          })
        }}
      >
        {bannerImage && <img src={bannerImage} height={bannerIconSize} width={bannerIconSize} />}
        <div className={s.textContainer}>
          <span className={s.bannerTitle}>{bannerTitle}</span>
          <span>{bannerDescription}</span>
        </div>
      </a>
      <div className={s.closeIcon} onClick={() => onClickBanner('close')}>
        <SVGIcon url={cross} />
      </div>
    </div>
  )
}

export default withOnlyGE(withFrenchSite(BlueAdBanner))
